import { Skeleton } from "@/components/ui/skeleton";

export const SidebarLoader = ({ className }: { className?: string }) => {
  return (
    <div
      className={`flex flex-col gap-[4px] items-center justify-center p-2 ${className}`}
    >
      {Array(4)
        .fill(null)
        .map((_, i) => (
          <div key={i} className="w-full flex gap-[2px]">
            <Skeleton className="flex-1 h-[28px] rounded-[8px] bg-[#F6F6F6]" />
          </div>
        ))}
    </div>
  );
};
